import { Card, CardContent, Grid } from "@mui/material";

export const NewCardsSection = ({ t, cardList }) => {
  const CardInfo = ({ title, value }) => {
    return (
      <Card className="border-radius">
        <CardContent>
          <Grid
            container
            rowSpacing={1}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Grid
              item
              xs={12}
              className="display-small__text-default text-center"
              textAlign="center"
            >
              <span>
                <p>{title[0]}</p>
                <p>{title[1]}</p>
                <p>{title[2] || <br />}</p>
              </span>
            </Grid>

            <Grid
              item
              xs={12}
              className="display-small__primary-one"
              textAlign="center"
            >
              {value}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  };

  const createCards = (card, key) => {
    const titleParts = 3;
    const titleWords = card?.name.split(" ");
    const fraction = Math.ceil(titleWords.length / titleParts);
    const title = [];

    for (let i = 0; i <= titleParts; i++) {
      const idxStart = i * fraction;

      const auxValue = (i + 1) * fraction;
      const idxEnd =
        auxValue > titleWords.length ? titleWords.length : auxValue;

      title[i] = titleWords.slice(idxStart, idxEnd).join(" ");
    }

    return (
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        lg={3}
        xl={cardList?.length <= 7 ? true : 1.7}
        key={key}
      >
        <CardInfo title={title} value={card?.value} />
      </Grid>
    );
  };

  return cardList.map((card, index) =>
    createCards(card, `${card?.value}-${index}`)
  );
};
